import { TagComponent } from '../tag/tag.component';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { BankingPartnerStore } from '@stores/partner.store';

@Component({
  selector: 'hlp-partner-tag',
  imports: [TagComponent],
  template: `
    @if (partner(); as partner) {
      <hlp-tag
        [backgroundColor]="partner.backgroundBtnColor"
        [customClasses]="customClasses()"
        innerClass="partner"
        label="{{ partner.label }}"
      >
      </hlp-tag>
    }
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerTagComponent {
  readonly bankingPartnerStore = inject(BankingPartnerStore);
  readonly customClasses = input<string>();
  readonly partnerId = input.required<string>();
  readonly partner = computed(() => this.bankingPartnerStore.partnerFromId(this.partnerId()));
}
